

import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/logo.svg";
import "./SideBar.css";
import {
  FiGrid,
  FiCalendar,
  FiUsers,
  FiCreditCard,
  FiFileText,
  FiHelpCircle,
  FiSettings,
  FiBell,
  FiMenu,
  FiX,
} from "react-icons/fi";

const Sidebar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  /** `to` matches paths in `RoutingApp.jsx` (`Route path`). Omit `to` when no route exists yet. */
  const navItems = [
    { name: "Dashboard", icon: <FiGrid />, to: "/" },
    { name: "Events", icon: <FiCalendar />, to: "/events" },
    { name: "Users", icon: <FiUsers />, to: "/users" },
    { name: "Payments", icon: <FiCreditCard /> },
    { name: "Home Page", icon: <FiFileText />, to: "/home-page" },
    { name: "About Page", icon: <FiFileText />, to: "/about" },
    { name: "FAQs", icon: <FiHelpCircle />, to: "/faqs" },
    { name: "Settings", icon: <FiSettings />, to: "/settings" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 860) {
        setIsMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* Mobile Menu Button */}
      <button className="menu-btn" onClick={toggleMobileMenu}>
        {isMobileOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      <aside className={`sidebar ${isMobileOpen ? 'is-open' : ''}`}>
        {/* Close button for mobile */}
        <button className="sidebar__close" onClick={closeMobileMenu}>
          <FiX />
        </button>

        {/* Logo Section */}
        <div className="logo-container">
          <img src={Logo} alt="Tillion Logo" className="logo" />
        </div>

        {/* Navigation Links */}
        <nav className="nav-menu">
          <ul>
            {navItems.map((item) => (
              <li key={item.name}>
                {item.to != null ? (
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      `nav-item${isActive ? " active" : ""}`
                    }
                    onClick={closeMobileMenu}
                  >
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.name}</span>
                  </NavLink>
                ) : (
                  <span
                    className="nav-item nav-item--disabled"
                    title="No page linked yet"
                  >
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.name}</span>
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer Help Box */}
        <div className="help-box">
          <div className="bell-icon">
            <FiBell />
          </div>
          <h4>Need Help?</h4>
          <p>Contact support for assistance</p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;